import { createContext } from "react";

export type StoreContextType = {
  storeId: string;
  firstServe: boolean;
};

export const StoreContext = createContext<StoreContextType>({ storeId: "", firstServe: false });
